import gql from "graphql-tag";
const onPublishResultSub = gql(` 
subscription OnPublishResult($id: String!) {
  onPublishResult(id: $id) {
    id
    result
  }
}
`)
export default onPublishResultSub;